var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.5C5.75736 5.5 4.75 6.50736 4.75 7.75C4.75 8.99264 5.75736 10 7 10C8.24264 10 9.25 8.99264 9.25 7.75C9.25 6.50736 8.24264 5.5 7 5.5ZM3.25 7.75C3.25 5.67893 4.92893 4 7 4C9.07107 4 10.75 5.67893 10.75 7.75C10.75 9.82107 9.07107 11.5 7 11.5C4.92893 11.5 3.25 9.82107 3.25 7.75ZM13 7.5C13 7.08579 13.3358 6.75 13.75 6.75H20.25C20.6642 6.75 21 7.08579 21 7.5C21 7.91421 20.6642 8.25 20.25 8.25H13.75C13.3358 8.25 13 7.91421 13 7.5ZM17 14.5C15.7574 14.5 14.75 15.5074 14.75 16.75C14.75 17.9926 15.7574 19 17 19C18.2426 19 19.25 17.9926 19.25 16.75C19.25 15.5074 18.2426 14.5 17 14.5ZM13.25 16.75C13.25 14.6789 14.9289 13 17 13C19.0711 13 20.75 14.6789 20.75 16.75C20.75 18.8211 19.0711 20.5 17 20.5C14.9289 20.5 13.25 18.8211 13.25 16.75ZM3 16.5C3 16.0858 3.33579 15.75 3.75 15.75H10.25C10.6642 15.75 11 16.0858 11 16.5C11 16.9142 10.6642 17.25 10.25 17.25H3.75C3.33579 17.25 3 16.9142 3 16.5Z",
    fill: "#000F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.c4609522c56f1c5c653bdade0f04b5b1.svg";
export { ForwardRef as ReactComponent };